import React, { useContext } from 'react';
import { PanelLeft, PanelLeftClose } from 'lucide-react';
import { AppSettings } from '../../config/app-settings.js';

export default function SidebarMinifyBtn() {
  const { appSidebarMinify, toggleAppSidebarMinify } = useContext(AppSettings);
  const isMinified = !!appSidebarMinify;

  return (
    <button
      type="button"
      className="donezo-sidebar-minify-btn d-none d-md-flex"
      onClick={toggleAppSidebarMinify}
      aria-pressed={isMinified}
      aria-label={isMinified ? 'Expand sidebar' : 'Collapse sidebar'}
      title={isMinified ? 'Expand sidebar' : 'Collapse sidebar'}
    >
      {isMinified ? (
        <PanelLeft size={18} strokeWidth={2.25} aria-hidden />
      ) : (
        <PanelLeftClose size={18} strokeWidth={2.25} aria-hidden />
      )}
      <span className="donezo-sidebar-minify-btn__label">
        {isMinified ? 'Expand' : 'Collapse'}
      </span>
    </button>
  );
}
